// extracted by mini-css-extract-plugin
export default {"switchButton":"SwitchButton__switchButton___tKIzO"};